import { render, staticRenderFns } from "./ActionsContent.vue?vue&type=template&id=6145e4c4"
import script from "./ActionsContent.vue?vue&type=script&lang=js"
export * from "./ActionsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports